import { createNode } from '@glueapp/graph-types';

export const TextPrimitive = createNode({
    id: 'Text',
    name: 'Text',
    description: 'A Node for holding a string',
    aiDescription: 'Passes a string through. Connect a string to "Input" or set its value directly; outputs on "Text" port.',
    category: 'Text',
    color: '#387cc8',
    integration: undefined,
    inPorts: {
        Input: { kind: 'string' },
    },
    outPorts: {
        Text: { kind: 'string' },
    },
    execute: function (input) {
        return { output: { Text: input.inPorts.Input } };
    },
});
